import {
  EllipsisIcon,
  RefreshCcwIcon,
  ShieldAlertIcon,
  ShieldCheckIcon,
  UserCheckIcon,
  UserMinusIcon,
} from 'lucide-react';
import type { CompanyManageableRole, CompanyMemberDTO } from '@shared/schemas/organization';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface CompanyMemberRowActionsProps {
  member: CompanyMemberDTO;
  isPending: boolean;
  onRoleChange: (userId: string, role: CompanyManageableRole) => void;
  onStatusChange: (userId: string, active: boolean) => void;
  onResendInvitation: (userId: string) => void;
}

export function CompanyMemberRowActions({ member, isPending, onResendInvitation, onRoleChange, onStatusChange }: CompanyMemberRowActionsProps) {
  return (
    <div className="flex items-center justify-end">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            aria-label={`Actions pour ${member.email}`}
            className="size-10 border-border bg-background text-foreground hover:border-foreground/20 hover:bg-muted dark:bg-muted dark:hover:bg-muted/80"
            data-testid={`company-member-actions-${member.id}`}
            disabled={isPending}
            size="icon-sm"
            variant="outline"
          >
            <EllipsisIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-60">
          <DropdownMenuGroup>
            <DropdownMenuLabel>Actions membre</DropdownMenuLabel>
            <DropdownMenuSeparator />
            {member.role !== 'owner' ? (
              <DropdownMenuItem
                onClick={() => onRoleChange(
                  member.id,
                  member.role === 'admin' ? 'member' : 'admin',
                )}
              >
                {member.role === 'admin' ? <ShieldAlertIcon /> : <ShieldCheckIcon />}
                {member.role === 'admin' ? 'Passer membre' : 'Passer administrateur'}
              </DropdownMenuItem>
            ) : null}
            <DropdownMenuItem onClick={() => onStatusChange(member.id, member.banned)}>
              {member.banned ? <UserCheckIcon /> : <UserMinusIcon />}
              {member.banned ? 'Réactiver le compte' : 'Désactiver le compte'}
            </DropdownMenuItem>
            {!member.emailVerified && !member.banned ? (
              <DropdownMenuItem
                data-testid={`company-member-resend-${member.id}`}
                onClick={() => onResendInvitation(member.id)}
              >
                <RefreshCcwIcon />
                Renvoyer l’e-mail d’activation
              </DropdownMenuItem>
            ) : null}
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
